module.exports = __webpack_public_path__ + "static/media/eng-popup-step3.a996714a.png";